webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(12);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(9);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _vueProgressbar = __webpack_require__(1);
	
	var _vueProgressbar2 = _interopRequireDefault(_vueProgressbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueProgressbar2.default);
	
	new _vue2.default({
	    el: 'body',
	    components: { App: _App2.default }
	});

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vueProgressbar = __webpack_require__(11);
	
	var _vueProgressbar2 = _interopRequireDefault(_vueProgressbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports.install = function (Vue) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    var $root = null;
	
	    Vue.mixin({
	        created: function created() {
	            if (!$root) {
	                if (this === this.$root) {
	                    $root = this;
	                    Vue.set($root, 'RADON_LOADING_BAR', {
	                        percent: 0,
	                        options: {
	                            canSuccess: true,
	                            show: false,
	                            color: options.color || 'rgb(143, 255, 199)',
	                            failedColor: options.failedColor || 'red',
	                            height: options.height || '2px'
	                        }
	                    });
	                    Vue.component('vue-progress-bar', _vueProgressbar2.default);
	                }
	            }
	        }
	    });
	
	    Vue.prototype.$Progress = {
	        timer: null,
	        cut: 0,
	        start: function start(time) {
	            var _this = this;
	
	            if (!time) time = 3000;
	            $root.RADON_LOADING_BAR.percent = 0;
	            $root.RADON_LOADING_BAR.options.show = true;
	            $root.RADON_LOADING_BAR.options.canSuccess = true;
	            this.cut = 10000 / Math.floor(time);
	            this.timer = setInterval(function () {
	                _this.increase(_this.cut * Math.random());
	                if ($root.RADON_LOADING_BAR.percent > 95) {
	                    _this.finish();
	                }
	            }, 100);
	        },
	        set: function set(num) {
	            $root.RADON_LOADING_BAR.options.show = true;
	            $root.RADON_LOADING_BAR.options.canSuccess = true;
	            $root.RADON_LOADING_BAR.percent = Math.floor(num);
	        },
	        get: function get() {
	            return Math.floor($root.RADON_LOADING_BAR.percent);
	        },
	        increase: function increase(num) {
	            $root.RADON_LOADING_BAR.percent = $root.RADON_LOADING_BAR.percent + Math.floor(num);
	        },
	        decrease: function decrease(num) {
	            $root.RADON_LOADING_BAR.percent = $root.RADON_LOADING_BAR.percent - Math.floor(num);
	        },
	        hide: function hide() {
	            clearInterval(this.timer);
	            this.timer = null;
	            setTimeout(function () {
	                $root.RADON_LOADING_BAR.options.show = false;
	                Vue.nextTick(function () {
	                    setTimeout(function () {
	                        $root.RADON_LOADING_BAR.percent = 0;
	                    }, 100);
	                });
	            }, 800);
	        },
	        finish: function finish() {
	            $root.RADON_LOADING_BAR.percent = 100;
	            this.hide();
	        },
	        fail: function fail() {
	            $root.RADON_LOADING_BAR.options.canSuccess = false;
	            $root.RADON_LOADING_BAR.percent = 100;
	            this.hide();
	        }
	    };
	};

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _content = __webpack_require__(10);
	
	var _content2 = _interopRequireDefault(_content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    components: {
	        docsContent: _content2.default
	    }
	};

/***/ },
/* 3 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    ready: function ready() {
	        this.$Progress.start();
	    },
	
	    methods: {
	        start: function start() {
	            this.$Progress.start();
	        },
	        set: function set(num) {
	            this.$Progress.set(num);
	        },
	        increase: function increase(num) {
	            this.$Progress.increase(num);
	        },
	        decrease: function decrease(num) {
	            this.$Progress.decrease(num);
	        },
	        finish: function finish() {
	            this.$Progress.finish();
	        },
	        fail: function fail() {
	            this.$Progress.fail();
	        }
	    }
	};

/***/ },
/* 4 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    computed: {
	        progress: function progress() {
	            return this.$root.RADON_LOADING_BAR;
	        }
	    }
	};

/***/ },
/* 5 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 6 */
/***/ function(module, exports) {

	module.exports = " <div id=app> <docs-content></docs-content> <vue-progress-bar></vue-progress-bar> </div> ";

/***/ },
/* 7 */
/***/ function(module, exports) {

	module.exports = " <section class=page-header> <h1 class=project-name>Vue-progressbar</h1> <h2 class=project-tagline>A lightweight progress bar for vue</h2> <p> <button class=btn @click=start>Start</button> <button class=btn @click=increase(10)>Increase(10)</button> <button class=btn @click=decrease(10)>Decrease(10)</button> <button class=btn @click=finish>Finish</button> <button class=btn @click=fail>Fail</button> <a href=https://github.com/hilongjw/vue-progressbar class=btn>View on GitHub</a> </p> </section> <section class=main-content> <h1> <a id=vue-progressbar class=anchor href=#vue-progressbar aria-hidden=true><span aria-hidden=true class=\"octicon octicon-link\"></span></a>vue-progressbar</h1> <h1> <a id=demo class=anchor href=#demo aria-hidden=true><span aria-hidden=true class=\"octicon octicon-link\"></span></a>Demo</h1> <p>The demo page is <a href=http://hilongjw.github.io/vue-progressbar/index.html>HERE</a>.</p> <h1> <a id=requirements class=anchor href=#requirements aria-hidden=true><span aria-hidden=true class=\"octicon octicon-link\"></span></a>Requirements</h1> <ul> <li> <a href=https://github.com/yyx990803/vue>Vue.js</a> <code>^1.0.0</code> </li> </ul> <h1> <a id=installation class=anchor href=#installation aria-hidden=true><span aria-hidden=true class=\"octicon octicon-link\"></span></a>Installation</h1> <h2> <a id=npm class=anchor href=#npm aria-hidden=true><span aria-hidden=true class=\"octicon octicon-link\"></span></a>npm</h2> <div class=\"highlight highlight-source-shell\"><pre>$ npm install vue-progressbar</pre></div> <h1> <a id=usage class=anchor href=#usage aria-hidden=true><span aria-hidden=true class=\"octicon octicon-link\"></span></a>Usage</h1> <p>main.js</p> <div class=\"highlight highlight-source-js\"><pre>\n<span class=pl-k>import</span> <span class=pl-smi>VueProgressBar</span> <span class=pl-k>from</span> <span class=pl-s><span class=pl-pds>'</span>vue-progressbar<span class=pl-pds>'</span></span>\n\n<span class=pl-smi>Vue</span>.<span class=pl-en>use</span>(VueProgressBar, {\n  color<span class=pl-k>:</span> <span class=pl-s><span class=pl-pds>'</span>rgb(143, 255, 199)<span class=pl-pds>'</span></span>,\n  failedColor<span class=pl-k>:</span> <span class=pl-s><span class=pl-pds>'</span>red<span class=pl-pds>'</span></span>,\n  height<span class=pl-k>:</span> <span class=pl-s><span class=pl-pds>'</span>2px<span class=pl-pds>'</span></span>\n})\n</pre></div> <p>Root App.vue</p> <div class=\"highlight highlight-text-html-basic\"><pre>&lt;<span class=pl-ent>template</span>&gt;\n    &lt;<span class=pl-ent>div</span> <span class=pl-e>id</span>=<span class=pl-s><span class=pl-pds>\"</span>app<span class=pl-pds>\"</span></span>&gt;\n        <span class=pl-c>&lt;!-- for example router view --&gt;</span>\n        &lt;<span class=pl-ent>router</span><span class=pl-e>-view</span>&gt;&lt;/<span class=pl-ent>router</span><span class=pl-e>-view</span>&gt;\n        <span class=pl-c>&lt;!-- set progressbar --&gt;</span>\n        &lt;<span class=pl-ent>vue</span><span class=pl-e>-progress-bar</span>&gt;&lt;/<span class=pl-ent>vue</span><span class=pl-e>-progress-bar</span>&gt;\n    &lt;/<span class=pl-ent>div</span>&gt;\n&lt;/<span class=pl-ent>template</span>&gt;</pre></div> <p>Any child </p> <div class=\"highlight highlight-text-html-basic\"><pre>\n<span class=pl-s1>&lt;<span class=pl-ent>script</span>&gt;</span>\n<span class=pl-s1><span class=pl-k>export</span> <span class=pl-v>default</span> {</span>\n<span class=pl-s1>  methods<span class=pl-k>:</span>{</span>\n<span class=pl-s1>    <span class=pl-en>start</span> () {</span>\n<span class=pl-s1>        <span class=pl-v>this</span>.<span class=pl-smi>$Progress</span>.<span class=pl-c1>start</span>()</span>\n<span class=pl-s1>    },</span>\n<span class=pl-s1>    <span class=pl-en>set</span> (<span class=pl-smi>num</span>) {</span>\n<span class=pl-s1>        <span class=pl-v>this</span>.<span class=pl-smi>$Progress</span>.<span class=pl-en>set</span>(num)</span>\n<span class=pl-s1>    },</span>\n<span class=pl-s1>    <span class=pl-en>increase</span> (<span class=pl-smi>num</span>) {</span>\n<span class=pl-s1>        <span class=pl-v>this</span>.<span class=pl-smi>$Progress</span>.<span class=pl-en>increase</span>(num)</span>\n<span class=pl-s1>    },</span>\n<span class=pl-s1>    <span class=pl-en>decrease</span> (<span class=pl-smi>num</span>) {</span>\n<span class=pl-s1>        <span class=pl-v>this</span>.<span class=pl-smi>$Progress</span>.<span class=pl-en>decrease</span>(num)</span>\n<span class=pl-s1>    },</span>\n<span class=pl-s1>    <span class=pl-en>finish</span> () {</span>\n<span class=pl-s1>        <span class=pl-v>this</span>.<span class=pl-smi>$Progress</span>.<span class=pl-en>finish</span>()</span>\n<span class=pl-s1>    },</span>\n<span class=pl-s1>    <span class=pl-en>fail</span> () {</span>\n<span class=pl-s1>        <span class=pl-v>this</span>.<span class=pl-smi>$Progress</span>.<span class=pl-en>fail</span>()</span>\n<span class=pl-s1>    },</span>\n<span class=pl-s1>    <span class=pl-en>test</span>(){</span>\n<span class=pl-s1>      <span class=pl-v>this</span>.<span class=pl-smi>$Progress</span>.<span class=pl-c1>start</span>()</span>\n<span class=pl-s1></span>\n<span class=pl-s1>      <span class=pl-v>this</span>.<span class=pl-smi>$http</span>.<span class=pl-en>jsonp</span>(<span class=pl-s><span class=pl-pds>'</span>http://api.rottentomatoes.com/api/public/v1.0/lists/movies/in_theaters.json?apikey=7waqfqbprs7pajbz28mqf6vz<span class=pl-pds>'</span></span>)</span>\n<span class=pl-s1>      .<span class=pl-en>then</span>((<span class=pl-smi>response</span>) <span class=pl-k>=&gt;</span> {</span>\n<span class=pl-s1>          <span class=pl-v>this</span>.<span class=pl-smi>$Progress</span>.<span class=pl-en>finish</span>()</span>\n<span class=pl-s1>      }, (<span class=pl-smi>response</span>) <span class=pl-k>=&gt;</span> {</span>\n<span class=pl-s1>          <span class=pl-v>this</span>.<span class=pl-smi>$Progress</span>.<span class=pl-en>fail</span>()</span>\n<span class=pl-s1>      })</span>\n<span class=pl-s1>    }</span>\n<span class=pl-s1>  }</span>\n<span class=pl-s1>}</span>\n<span class=pl-s1>&lt;/<span class=pl-ent>script</span>&gt;</span>\n</pre></div> <h1> <a id=license class=anchor href=#license aria-hidden=true><span aria-hidden=true class=\"octicon octicon-link\"></span></a>License</h1> <p><a href=http://opensource.org/licenses/MIT>The MIT License</a></p> <footer class=site-footer> <span class=site-footer-owner><a href=https://github.com/hilongjw/vue-progressbar>Vue-progressbar</a> is maintained by <a href=https://github.com/hilongjw>hilongjw</a>.</span> <span class=site-footer-credits>This page was generated by <a href=https://pages.github.com>GitHub Pages</a> using the <a href=https://github.com/jasonlong/cayman-theme>Cayman theme</a> by <a href=https://twitter.com/jasonlong>Jason Long</a>.</span> </footer> </section> ";

/***/ },
/* 8 */
/***/ function(module, exports) {

	module.exports = " <div class=cov-progress :style=\"{\n  'width': progress.percent+'%',\n  'height': progress.options.height,\n  'background-color': progress.options.canSuccess? progress.options.color : progress.options.failedColor,\n  'opacity': progress.options.show ? 1 : 0\n}\" _v-79894762=\"\"> </div> ";

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(2)
	__vue_template__ = __webpack_require__(6)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(3)
	__vue_template__ = __webpack_require__(7)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(5)
	__vue_script__ = __webpack_require__(4)
	__vue_template__ = __webpack_require__(8)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ }
]);


/** WEBPACK FOOTER **
 ** static/js/app.74cfad8bf04655cb5fc1.js
 **/